/**
 * MyCirclesSurface — the dashboard's accountability circle surface.
 *
 * Decides whether to show the new multi-circle list (`MyCirclesWidget`) or
 * the legacy single-circle widget based on how many active circles the user
 * belongs to.
 *
 *   0 or 1 circle  → AccountabilityCircleWidget (existing UX)
 *   2+ circles     → MyCirclesWidget (new compact multi-circle list)
 *
 * This keeps the existing experience untouched for the majority of sisters
 * who are in a single circle, while introducing the new surface only for
 * those who've opted into multi-circle membership.
 */

import { useEffect, useState } from 'react';
import axios from 'axios';
import AccountabilityCircleWidget from './AccountabilityCircleWidget';
import MyCirclesWidget from './MyCirclesWidget';

const API_URL = window.location.origin;

const MyCirclesSurface = ({ className = '' }) => {
  const [count, setCount] = useState(null); // null = still loading

  useEffect(() => {
    (async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await axios.get(`${API_URL}/api/accountability-circle/my-circles`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setCount((res.data?.circles || []).length);
      } catch {
        setCount(0);
      }
    })();
  }, []);

  if (count === null) {
    // While we figure out which surface to render, fall back to the legacy
    // single-circle widget so the dashboard isn't blank.
    return <AccountabilityCircleWidget className={className} />;
  }

  if (count >= 2) {
    return <MyCirclesWidget className={className} />;
  }

  return <AccountabilityCircleWidget className={className} />;
};

export default MyCirclesSurface;
